export default __webpack_public_path__ + "static/media/our-team-2.4de8b4e0.jpg";